import React, { useContext, useState } from 'react'
import { Flex, Box } from 'pcln-design-system'
import StyledHeading from '@/components/StyledHeading'
import HotelsTonight from '@/components/HotelsTonight/HotelsTonight'
import PromoFeatureBox from '@/components/PromoFeatureBox'
import Form from '@/components/Hotels/SearchForm/Form'
import SmsOptIn from '@/components/SmsOptIn'
import ConditionalRender, { Experiment } from '@/components/ConditionalRender'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import { handleSubmitForHotels } from '@/components/Hotels/SearchForm/utils'
import MobileHeaderWrapper from '@/components/MobileHeaderWrapper/MobileHeaderWrapper'
import useMostRecentFutureBooking from '@/hooks/useMostRecentFutureBooking'
import CrossSell from '@/components/CrossSell'
import { EmailSignUpToast } from '@/components/EmailSignUp'
import CONTENT from '@/constants/content'
import useSEMSearchHeadline from '@/hooks/useSEMSearchHeadline'
import MarketingTout from '@/components/Promos/MarketingTout/MarketingTout'
import ExtendStay from '@/components/ExtendStay'
import useCityNameInFormHeadlineForSEM from '@/hooks/useCityNameInFormHeadlineForSEM'
import useContentfulSearchFormHeadlines from '@/hooks/useContentfulSearchFormHeadlines'
import useExtendStayBooking from '@/hooks/useExtendStayBooking'
import { LOCATION_SEARCH_TYPE } from '@/types'
import SearchFormProvider from '@/context/SearchFormContext'
import { HotelsBumper } from '../SearchForm/Bumpers'

const PRIMARY_HEADING_FALLBACK = 'Find your next hotel deal'

export default function HomeMobile() {
  const mostRecentFutureBooking = useMostRecentFutureBooking()
  const {
    signInStatus: { signedIn, passiveSignIn },
    customer: { firstName }
  } = useContext(BootstrapDataContext)

  const extendData = useExtendStayBooking()
  const isSignedIn = signedIn || passiveSignIn
  const [location, setLocation] = useState<LOCATION_SEARCH_TYPE | undefined>()
  const prePopHeadline = useCityNameInFormHeadlineForSEM(location)
  const SEMHeadline = useSEMSearchHeadline()
  const form = useContentfulSearchFormHeadlines('searchFormHotels')
  /**
   * TODO: Add these values to contentful
   */
  const headlineVIP = firstName
    ? CONTENT.homepage.vip.headlineWithName.replace('{firstName}', firstName)
    : CONTENT.homepage.vip.defaultHeading
  const subheadline = isSignedIn
    ? CONTENT.homepage.hotel.signedInSubHeading
    : form?.mobileSubheadline || ''

  const headline = isSignedIn
    ? headlineVIP
    : prePopHeadline ||
      SEMHeadline ||
      form?.mobileHeadline ||
      PRIMARY_HEADING_FALLBACK

  const CrossSellContent = () => {
    return (
      <>
        {mostRecentFutureBooking ? (
          <CrossSell booking={mostRecentFutureBooking} />
        ) : (
          <PromoFeatureBox />
        )}
      </>
    )
  }

  return (
    <Box>
      <MobileHeaderWrapper selectedProductName="Hotels" mb={4}>
        <SearchFormProvider>
          <Box px={3}>
            <Flex flexDirection="column">
              <StyledHeading
                tag="h1"
                color="text.heading"
                textStyle="heading3"
                text={headline}
              />
              <StyledHeading
                mt={1}
                tag="h2"
                color="text.light"
                textStyle="subheading6"
                text={subheadline}
              />
            </Flex>
            <Box mt={3}>
              <Form
                onSubmit={handleSubmitForHotels}
                setLocation={setLocation}
              />
            </Box>
          </Box>
          <HotelsBumper />
        </SearchFormProvider>
      </MobileHeaderWrapper>
      <Box m={3}>
        {extendData ? <ExtendStay {...extendData} /> : <CrossSellContent />}
      </Box>
      <Box m={3} mt="48px">
        <ConditionalRender experimentCode="HP_SMS_COMPONENT">
          <Experiment>
            <SmsOptIn />
          </Experiment>
        </ConditionalRender>
        <MarketingTout />
      </Box>
      <Box m={3}>
        <HotelsTonight />
        <Box textAlign="center" mt={4} width={1}>
          <div id="div-gpt-ad-1544641976893-0" />
        </Box>
      </Box>
      <EmailSignUpToast sourceId="LANDING_HOME_TOAST_MWEB" isMobile />
    </Box>
  )
}
